/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { locale } from '../../common/localization/localizationService';
import ContractorAdmin from '../contractorAdmin';
import Vehicles from '../vehicles';
import Deviations from '../deviations';
import DeviationCategories from '../deviationCategories';
import { isNil } from 'lodash';
import { IUser } from '../../models';
import UserAdmin from '../userAdmin';
import EventBus from '../../common/EventBus';
import Depots from '../depots';
import Fractions from '../fractions';
import Units from '../units';
import { History } from 'history';
import OrderExclusionsAdmin from '../orderExclusionsAdmin';
import { hasRole } from '../../utils/GeneralUtils';
import { UserRoles } from '../../redux/modules/auth';

export interface IAdministrationPageProps {
  authentication: IUser;
  history: History;
}

const AdministrationPage: React.FC<IAdministrationPageProps> = ({
  // eslint-disable-next-line react/prop-types
  authentication,
  history,
}) => {
  const params = new URLSearchParams(document.location.search);
  const page = params.get('page');
  let activeTabIndex = 0;
  if (page === 'exclusion-days') {
    activeTabIndex =
      hasRole(authentication.auth0Roles, [UserRoles.SUPERADMINISTRATOR]) ||
      isNil(authentication.contractorId)
        ? 7
        : 6;
  }

  const [activeTab, setActiveTab] = useState(activeTabIndex);
  useEffect(() => {
    EventBus.emit('fullScreenChange', true);

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, []);
  return (
    <div>
      {hasRole(authentication.auth0Roles, []) && (
        <TabStrip
          selected={activeTab}
          onSelect={(e) => setActiveTab(e.selected)}
        >
          <TabStripTab title={locale.general._vehicles}>
            {activeTab === 0 && <Vehicles history={history} />}
          </TabStripTab>
          {(hasRole(authentication.auth0Roles, [
            UserRoles.SUPERADMINISTRATOR,
          ]) ||
            isNil(authentication.contractorId)) && (
            <TabStripTab title={locale.contractors._contractors}>
              {activeTab === 1 && <ContractorAdmin />}
            </TabStripTab>
          )}
          <TabStripTab title={locale.deviations._deviations}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 2
                : 1) && <Deviations />}
          </TabStripTab>
          <TabStripTab title={locale.deviations._deviationCategory}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 3
                : 2) && <DeviationCategories />}
          </TabStripTab>
          <TabStripTab title={locale.depots._depots}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 4
                : 3) && <Depots />}
          </TabStripTab>
          <TabStripTab title={locale.fractions._fractions}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 5
                : 4) && <Fractions />}
          </TabStripTab>
          <TabStripTab title={locale.units._units}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 6
                : 5) && <Units />}
          </TabStripTab>
          <TabStripTab title={locale.orderExclusions._exclusionDays}>
            {activeTab ===
              (hasRole(authentication.auth0Roles, [
                UserRoles.SUPERADMINISTRATOR,
              ]) || isNil(authentication.contractorId)
                ? 7
                : 6) && <OrderExclusionsAdmin />}
          </TabStripTab>
          {(hasRole(authentication.auth0Roles, [
            UserRoles.SUPERADMINISTRATOR,
          ]) ||
            isNil(authentication.contractorId)) && (
            <TabStripTab title={locale.general._userAdmin}>
              {activeTab === 8 && <UserAdmin />}
            </TabStripTab>
          )}
        </TabStrip>
      )}
    </div>
  );
};

export default AdministrationPage;
